<script lang="ts" setup>
defineProps<{
  icon?: string
  title: string
  subtitle?: string
}>()
</script>

<template>
  <div v-once class="text-neutral-600">
    <Icon :name="icon || 'solar:face-scan-square-bold-duotone'" class="mb-10 text-80px" />
    <h2 class="mb-3 text-heading-2">
      {{ title }}
    </h2>

    <p class="text-base">
      <slot name="subtitle">
        {{ subtitle }}
      </slot>
    </p>
  </div>
</template>
